module.exports = __webpack_public_path__ + "resource/img/check.e61ab83f.svg";